import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';

const setupFCM = async (firebaseConfig, fcm_vapidkey, displayNotification, saveToken) => {
    firebaseConfig = JSON.parse(firebaseConfig.replace(/'/g, '"'));
    firebaseConfig = {
      apiKey: firebaseConfig.api_key,
      authDomain: firebaseConfig.auth_domain,
      projectId: firebaseConfig.project_id,
      storageBucket: firebaseConfig.storage_bucket,
      messagingSenderId: firebaseConfig.messaging_sender_id,
      appId: firebaseConfig.app_id,
    }
    const app = initializeApp(firebaseConfig);

    const isSupportedBrowser = await isSupported();
    if (!isSupportedBrowser) {
      return;
    }

    const messaging = getMessaging(app);
    onMessage(messaging, (payload) => {
      displayNotification(payload.notification.title, payload.notification.body, payload.data)
    });

    const currentToken = await getToken(messaging, { vapidKey: fcm_vapidkey }).catch((err) => {
      console.log('Alert: Unable to retrieving token for push notifications. Push notification permission might not enabled.');
    });

    if (currentToken) {
      await saveToken(currentToken);
    } else {
      console.log('Alert: No registration token available. Request permission to generate one.');
    }

}

const requestNotifications = async (firebaseConfig, fcm_vapidkey, errorToast) => {
    firebaseConfig = JSON.parse(firebaseConfig.replace(/'/g, '"'));
    firebaseConfig = {
      apiKey: firebaseConfig.api_key,
      authDomain: firebaseConfig.auth_domain,
      projectId: firebaseConfig.project_id,
      storageBucket: firebaseConfig.storage_bucket,
      messagingSenderId: firebaseConfig.messaging_sender_id,
      appId: firebaseConfig.app_id,
    }
    const app = initializeApp(firebaseConfig);

    const isSupportedBrowser = await isSupported();
    if (!isSupportedBrowser) {
      return;
    }

    const messaging = getMessaging(app);
    
    const currentToken = await getToken(messaging, { vapidKey: fcm_vapidkey }).catch((err) => {
      console.log(err);
      errorToast('Error', 'An error occurred while trying to enable push notifications. Make sure to allow notifications for Lodgix.com in your browser settings.');
    });

    return currentToken;

}

const isSupportedBrowser = async () => {
  const isSupportedBrowser = await isSupported();
  return isSupportedBrowser;
}

export { setupFCM, requestNotifications, isSupportedBrowser }